<script>
import EbLink from '../eb-link/eb-link';
export default {
  name: 'EbDropdownItem',
  functional: true,
  components: { EbLink },
  render(createElement, context) {
    return createElement(
      'eb-link',
      {
        class: {
          'dropdown-item': true
        }
      },
      context.slots().default
    );
  }
};
</script>

<style scoped>
.dropdown-item {
  color: #6e7687;
}
.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover,
.dropdown-item:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #f8f9fa;
}
</style>